import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, message, Select, DatePicker } from "antd";
import { SelectEmployee } from "../SelectInput";
import { getRequest } from "../../utils/APICall";
import TaskTable from "./taskTable";
import dayjs from "dayjs";
import { DownloadOutlined } from "@ant-design/icons";
import downloadTaskTablePdf from "./taskeTablePdf"; // Fixed import name
import moment from "moment";

const { Option } = Select;
const { RangePicker } = DatePicker;

const TaskForm = ({ onEdit, tableReFetchData }) => {
  const { allEmployee } = useSelector((state) => state.employees);
  const [employeeId, setEmployeeId] = useState(null);
  const [status, setStatus] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employeName, setEmployeName] = useState("");




  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array?.filter((item) => {
      if (seen.has(item.ID)) return false;
      seen.add(item.ID);
      return true;
    });
  }
  const filterData = removeDuplicatesByID(allEmployee);

  //  Initial Load (getAllTask)
  const fetchTasks = async () => {
    setLoading(true);
    const result = await getRequest("getAllTask");
    // console.log("result ",result)
    if (result?.success) {
      setTasks(result?.data);
    } else {
      message.error("Failed to fetch tasks");
      setTasks([])
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchTasks();
  }, [tableReFetchData]);

  //  New API (Employee + Status + Date Range)
  const handleSearch = async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams();
      if (employeeId) params.append("empid", employeeId);
      if (status !== null) params.append("status", status);

      if (dateRange.length === 2) {
        params.append("fromdate", dayjs(dateRange[0]).format("DD-MM-YYYY"));
        params.append("todate", dayjs(dateRange[1]).format("DD-MM-YYYY"));
      }
      // console.log(params.toString());
      const result = await getRequest(`getTaskByStatus?${params.toString()}`);
      // console.log(result.success)
      if (result.success) {
        setTasks(result.tasks);
      } else {
        // message.error("Error fetching tasks");
        console.error(result.error);
      }
    } catch (err) {
      console.error("Search error:", err);
      message.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  // Define columns for PDF (similar to TaskTable columns)
  const getPdfColumns = () => [
    { title: "S.No", dataIndex: "serialNo" },
    { title: "Subject", dataIndex: "CLIENTTITLE" },
    { title: "Project ", dataIndex: "TITLE" },
    { title: "Features", dataIndex: "WORK_TYPE" },
    { title: "Assign Date", dataIndex: "ASSIGNDATE" },
    { title: "Due Date", dataIndex: "DUE_DATE" },
    { title: "Complain By", dataIndex: "COMPLAINBY" },
    { title: "Assigned Staff", dataIndex: "EMPLOYEE_NAMES" },
    { title: "Priority", dataIndex: "PRIORITY_TITLE" },
    { title: "Status", dataIndex: "STATUS" },
    // { title: "Approved By", dataIndex: "APPROVEBY" },
    // { title: "Approved Date", dataIndex: "APPROVEDATE" },
    { title: "Complete Date", dataIndex: "COMPLETEDATE" },
    { title: "Days Taken", dataIndex: "COMPLETE_DURATION_DAYS" },
    { title: "Description", dataIndex: "DESCRIPTION" },
  ];

  const handleDownloadPdf = async () => {
    if (!tasks || tasks.length === 0) {
      message.warning("No data available to download");
      return;
    }

    const formattedFromDate = dateRange.length > 0 ? moment(dateRange[0].$d).format("DD-MMM-YYYY") : "No Date Selected";
    const formattedToDate = dateRange.length > 1 ? moment(dateRange[1].$d).format("DD-MMM-YYYY") : "No Date Selected";

    downloadTaskTablePdf(
      getPdfColumns(),
      tasks,
      formattedFromDate,
      formattedToDate,
      employeName || "All" 
    );
  };


  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
        {/* Employee Dropdown */}
        <div className="md:col-span-2">
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Employee
          </label>
          <SelectEmployee
            employeeList={filterData}
            onChange={(value) => {
              setEmployeeId(value);
              const emp = allEmployee.find((e) => e.ID === value);
              setEmployeName(emp ? emp.NAME : "");
            }}
            selectedEmployee={employeeId}
            customStyle="w-full"
            allLabel={{}}
          />

        </div>

        {/* Status Dropdown */}
        <div className="md:col-span-2">
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Status
          </label>
          <Select
            placeholder="Select Status"
            allowClear
            onChange={(value) => setStatus(value ?? null)}
            value={status}
            className="w-full h-10"
          >
            <Option value={0}>Assigned</Option>
            <Option value={1}>In Process</Option>
            <Option value={2}>On Hold</Option>
            <Option value={3}>Completed</Option>
            <Option value={4}>Rejected</Option>
            <Option value={5}>Canceled</Option>
            {/* <Option value={6}>Ended</Option> */}
          </Select>
        </div>

        {/* Date Range Picker */}
        <div className="md:col-span-4">
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Date Range
          </label>
          <RangePicker
            className="w-full h-10"
            format="DD-MM-YYYY"
            value={dateRange}
            onChange={(val) => setDateRange(val || [])}
          // onChange={rangePickerHandler}
          />
        </div>

        {/* Search Button */}
        <div className="md:col-span-2">
          <Button
            type="primary"
            className="w-full h-10 text-lg font-bold text-gray-100 p-4 md:px-10"
            onClick={handleSearch}
            loading={loading}
          >
            SEARCH
          </Button>
        </div>

        {/* Download PDF Button */}
        <div className="md:col-span-2">
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            className="w-full h-10 text-lg font-bold bg-green-600 hover:bg-green-700 text-white"
            onClick={handleDownloadPdf}
            disabled={!tasks || tasks.length === 0}
          >
            PDF
          </Button>
        </div>
      </div>

      <div className="mt-6">
        <TaskTable data={tasks} onEdit={onEdit} loading={loading} />
      </div>
    </>
  );
};

export default TaskForm;